export default __webpack_public_path__ + "static/media/background_cross.f1026828.svg";